import script from "./BlockProject.vue?vue&type=script&setup=true&lang=js"
export * from "./BlockProject.vue?vue&type=script&setup=true&lang=js"

import "./BlockProject.vue?vue&type=style&index=0&id=6614f117&lang=scss"

const __exports__ = script;

export default __exports__